function calculateLessons(program) {
  return program.modules.reduce((total, module) => total + module.lessons.length, 0);
}

function calculateMinutes(program) {
  const lessonsQuantity = calculateLessons(program);

  return lessonsQuantity * 90;
}

const egeMathProfile = {
  title: 'Программа курса по профильной математике',
  schedule: 'Ср в 16:00 и Сб в 18:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Вычисления и преобразования рацональных и иррациональных выражений (№5, 9)',
          day: 'чт',
          date: '15.02',
        },
        {
          name: 'Простейшие уравнения',
          day: 'пн',
          date: '20.02',
        },
        {
          name: 'Показательная функция',
          day: 'чт',
          date: '22.02',
        },
        {
          name: 'Логарифмическая функция',
          day: 'пн',
          date: '26.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Основы тригонометрии',
          day: 'чт',
          date: '29.02',
        },
        {
          name: 'Тригонометрические преобразования',
          day: 'пн',
          date: '04.03',
        },
        {
          name: 'Вычисления по формулам ',
          day: 'чт',
          date: '07.03',
        },
        {
          name: 'Задачи на движение',
          day: 'пн',
          date: '11.03',
        },
        {
          name: 'Задачи на совместную работу. Задачи на сплавы. Прогрессии (№11)',
          day: 'пн',
          date: '18.03',
        },
        {
          name: 'Теория вероятностей',
          day: 'чт',
          date: '21.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Графики функций',
          day: 'пн',
          date: '25.03',
        },
        {
          name: 'Производные и первообразные (№7)',
          day: 'чт',
          date: '28.03',
        },
        {
          name: 'Алгоритм нахождения экстремумов (№12)',
          day: 'пн',
          date: '01.04',
        },
        {
          name: 'Треугольники',
          day: 'чт',
          date: '04.04',
        },
        {
          name: 'Многоугольники',
          day: 'пн',
          date: '08.04',
        },
        {
          name: 'Окружности',
          day: 'чт',
          date: '11.04',
        },
        {
          name: 'Параллелепипед. Тела вращения',
          day: 'пн',
          date: '15.04',
        },
        {
          name: 'Призма и пирамида',
          day: 'чт',
          date: '18.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Тригонометрические уравнения (№12)',
          day: 'пн',
          date: '15.04',
        },
        {
          name: 'Показательные и логарифмические уравнения (№12)',
          day: 'чт',
          date: '18.04',
        },
        {
          name: 'Смешанные уравнения (№12)',
          day: 'пн',
          date: '22.04',
        },
        {
          name: 'Основы решения неравентсв. Показательные неравенства',
          day: 'чт',
          date: '25.04',
        },
        {
          name: 'Логарифмические неравенства',
          day: 'пн',
          date: '29.04',
        },
        {
          name: 'Решения неравенств методом рационализации',
          day: 'чт',
          date: '02.05',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Задача на банки - аннуитетные платежи, дифференциованные платежи',
          day: 'пн',
          date: '06.05',
        },
        {
          name: 'Оптимизация',
          day: 'чт',
          date: '09.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пн',
          date: '13.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '16.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '20.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '23.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '30.05',
        },
      ],
    },
  ],
};

const egeMath = {
  title: 'Программа курса по базовой математике',
  schedule: 'Пн в 17:40 и Чт в 17:40',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Дроби. Пропорции. Чтение графиков. Простейшие текстовые задачи',
          day: 'чт',
          date: '15.02',
        },
        {
          name: 'Действия с простейшими алгебраическими выражениями.',
          day: 'пн',
          date: '20.02',
        },
        {
          name: 'Уравнения с одной переменной',
          day: 'чт',
          date: '22.02',
        },
        {
          name: 'Неравенства',
          day: 'пн',
          date: '26.02',
        },
        {
          name: 'Нестандартные задачи на неравенства.',
          day: 'чт',
          date: '29.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Логарифмические и показательные уравнения и неравенства',
          day: 'пн',
          date: '04.03',
        },
        {
          name: 'Тригонометрические уравнения. Вычисления по формулам',
          day: 'чт',
          date: '07.03',
        },
        {
          name: 'Преобразования выражений. Анализ и сопоставления данных на графиках. ',
          day: 'пн',
          date: '11.03',
        },
        {
          name: 'Теория Вероятностей.  ',
          day: 'пн',
          date: '18.03',
        },
        {
          name: 'Производная ',
          day: 'чт',
          date: '21.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Выбор оптимального варианта',
          day: 'пн',
          date: '25.03',
        },
        {
          name: 'Логика. Делимость. Задачи на сложную логику',
          day: 'чт',
          date: '28.03',
        },
        {
          name: 'Задачи на движение ',
          day: 'пн',
          date: '01.04',
        },
        {
          name: 'Задачи на сплавы и работу',
          day: 'чт',
          date: '04.04',
        },
        {
          name: 'Планиметрия. Треугольники',
          day: 'пн',
          date: '08.04',
        },
        {
          name: 'Планиметрия. Четырехугольники.',
          day: 'чт',
          date: '11.04',
        },
        {
          name: 'Треугольник',
          day: 'пн',
          date: '15.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Окружность',
          day: 'чт',
          date: '18.04',
        },
        {
          name: 'Параллелограмм',
          day: 'пн',
          date: '15.04',
        },
        {
          name: 'Трапеция',
          day: 'чт',
          date: '18.04',
        },
        {
          name: 'Призма. Параллелепипед. Пирамида',
          day: 'пн',
          date: '22.04',
        },
        {
          name: 'Цилиндр. Шар',
          day: 'чт',
          date: '25.04',
        },
        {
          name: 'Конус',
          day: 'пн',
          date: '29.04',
        },
        {
          name: 'Прикладные задачи на геометрию.Задачи с картами',
          day: 'чт',
          date: '02.05',
        },
        {
          name: 'Прикладные задачи на стереометрию',
          day: 'пн',
          date: '06.05',
        },
        {
          name: 'Графики. Чтение графиков. Работа с графиками',
          day: 'чт',
          date: '09.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пн',
          date: '13.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '16.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '20.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '23.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '30.05',
        },
      ],
    },
  ],
};

const egeBiology = {
  title: 'Программа курса по биологии',
  schedule: 'Пн в 19:20 и Чт в 17:40',
  modules: [
    {
      name: 'Клеточная биология',
      lessons: [
        {
          name: 'Цитология. Химическая организация и строение клетки',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Цитология. Жизненный цикл и деление клетки',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Метаболизм. Генетическая информация в клетке, биосинтез белка. Часть 1',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Метаболизм. Генетическая информация в клетке, биосинтез белка. Часть 2',
          day: 'ср',
          date: '28.02',
        },
      ],
    },
    {
      name: 'Размножение, генетика, селекция и биотехнология',
      lessons: [
        {
          name: 'Размножение и онтогенез',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Генетика. Часть 1',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Генетика. Часть 2',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Генетика. Часть 3',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Селекция и биотехнология',
          day: 'сб',
          date: '16.03',
        },
      ],
    },
    {
      name: 'Ботаника',
      lessons: [
        {
          name: 'Вирусы, бактерии',
          day: 'ср',
          date: '18.03',
        },
        {
          name: 'Грибы, лишайники',
          day: 'сб',
          date: '23.03',
        },
        {
          name: 'Ботаника. Морфология и анатомия растений',
          day: 'ср',
          date: '25.03',
        },
        {
          name: 'Ботаника. Многообразие растений и их жизненные циклы',
          day: 'сб',
          date: '30.03',
        },
      ],
    },
    {
      name: 'Животные',
      lessons: [
        {
          name: 'Многообразие беспозвоночных животных. Часть 1',
          day: 'ср',
          date: '01.04',
        },
        {
          name: 'Многообразие беспозвоночных животных. Часть 2',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Многообразие беспозвоночных животных. Часть 3',
          day: 'ср',
          date: '08.04',
        },
        {
          name: 'Многообразие позвоночных животных. Часть 1',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Многообразие позвоночных животных. Часть 2',
          day: 'ср',
          date: '15.04',
        },
        {
          name: 'Многообразие позвоночных животных. Часть 3',
          day: 'сб',
          date: '20.04',
        },
      ],
    },
    {
      name: 'Системы органов человека',
      lessons: [
        {
          name: 'Системы органов человека. Часть 1',
          day: 'ср',
          date: '22.04',
        },
        {
          name: 'Системы органов человека. Часть 2',
          day: 'сб',
          date: '27.04',
        },
        {
          name: 'Системы органов человека. Часть 3',
          day: 'ср',
          date: '29.04',
        },
        {
          name: 'Системы органов человека. Часть 4',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Системы органов человека. Часть 5',
          day: 'ср',
          date: '06.05',
        },
        {
          name: 'Системы органов человека. Часть 6',
          day: 'сб',
          date: '11.05',
        },
      ],
    },
    {
      name: 'Эволюция и Экология',
      lessons: [
        {
          name: 'Эволюция. Макроэволюция и микроэволюция',
          day: 'ср',
          date: '13.05',
        },
        {
          name: 'Эволюция органического мира',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Экология',
          day: 'ср',
          date: '20.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '01.06',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '03.06',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '07.06',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '10.06',
        },
      ],
    },
  ],
};

const egeEnglish = {
  title: 'Программа курса по английскому языку',
  schedule: 'Ср в 16:00 и Пт в 16:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Вводное занятие',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Family and friends + Impersonal sentences / There is / there are',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'At home + Phonetics',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Food and drink + Questions',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Revision 1',
          day: 'пт',
          date: '01.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Health and fitness + Present tenses',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Education + Past tenses',
          day: 'пт',
          date: '08.03',
        },
        {
          name: 'Science and technology + Future tenses',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Work and business + Passive voice',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'Revision 2',
          day: 'ср',
          date: '20.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Money and shopping + Pronouns / Comparatives and superlatives',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Weather and the environment + Articles',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Travel and transport + Conditionals',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Entertainment + Unreal past',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Revision 3',
          day: 'пт',
          date: '05.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'People and society + Reported speech',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Social Media + Modals',
          day: 'пт',
          date: '12.04',
        },
        {
          name: 'The media + Relative clauses & participles',
          day: 'ср',
          date: '17.04',
        },
        {
          name: 'Hobbies, sport and games + -ing vs infinitive',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Revision 4',
          day: 'ср',
          date: '24.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'People and objects description',
          day: 'пт',
          date: '26.04',
        },
        {
          name: 'Confusing words and false friends',
          day: 'ср',
          date: '01.05',
        },
        {
          name: 'Phrasal Verbs',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Tenses Revision',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Revision 5',
          day: 'пт',
          date: '10.05',
        },
      ],
    },
    {
      name: 'Модуль 6',
      lessons: [
        {
          name: 'I wish, stop, forget, remember, it`s time',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Phrasal verbs revision',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Conditionals revision',
          day: 'ср',
          date: '22.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Revision',
          day: 'пт',
          date: '24.05',
        },
        {
          name: 'Revision',
          day: 'ср',
          date: '29.05',
        },
        {
          name: 'Revision',
          day: 'пт',
          date: '31.05',
        },
        {
          name: 'Revision',
          day: 'ср',
          date: '05.06',
        },
        {
          name: 'Revision',
          day: 'пт',
          date: '07.06',
        },
        {
          name: 'Revision',
          day: 'ср',
          date: '12.06',
        },
      ],
    },
  ],
};

const egeLiterature = {
  title: 'Программа курса по литературе',
  schedule: 'Вт в 16:00 и Пт в 16:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Фольклор. Древнерусская литература: "Слово о Полку Игореве"',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Д.И Фонвизин "Недоросль", А.С Грибоедов "Горе от ума"',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'Лирика Г.Р. Державина и В.А. Жуковского',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Лирика А.С. Пушкина и поэма "Медный всадник"',
          day: 'вт',
          date: '27.02',
        },
        {
          name: 'А.С Пушкин "Евгений Онегин" А.С Пушкин "Капитанская дочка"',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Лирика и поэмы М.Ю Лермонтова М.Ю Лермонтов "Герой нашего времени"',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Н.В Гоголь "Ревизор", "Шинель"',
          day: 'пт',
          date: '08.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Н.В Гоголь "Мертвые Души"',
          day: 'вт',
          date: '12.03',
        },
        {
          name: 'И.С Тургенев «Отцы и дети»',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'А.Н Островский «Гроза» И.А Гончаров «Обломов»',
          day: 'вт',
          date: '19.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Лирика Ф.И Тютчева; лирика А.А. Фета',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Лирика Н.А Некрасова и поэма "Кому на Руси жить хорошо"',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'Творчество М.Е Салтыкова-Щедрина',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Зарубежная поэзия',
          day: 'вт',
          date: '02.04',
        },
        {
          name: 'Ф.М Достоевский "Преступление и Наказание"',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Л.Н Толстой "Война и Мир"',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Творчество А.П Чехова',
          day: 'пт',
          date: '12.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Творчество И.А Бунина + Творчество М. Горького',
          day: 'вт',
          date: '16.04',
        },
        {
          // eslint-disable-next-line max-len,vue/max-len
          name: 'Серебряный век (I): обзорное занятие (течения и их представители); Лирика А.А. Блока и М.И. Цветаевой О.Э. Мандельштама, А.А. Ахматовой Лирика С.А. Есенина и В. В. Маяковского',
          day: 'пт',
          date: '19.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          // eslint-disable-next-line max-len,vue/max-len
          name: 'Творчество М.А Шолохова + Творчество А.И Солженицына ("Матренин двор", "Один день Ивана Денисовича") и В.Т. Шаламов',
          day: 'вт',
          date: '23.04',
        },
        {
          name: 'Творчество поэтов советского периода (Твардовский, Симонов, Пастернак) +',
          day: 'пт',
          date: '26.04',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пн',
          date: '13.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '16.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '20.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '23.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '30.05',
        },
      ],
    },
  ],
};

const egeRussian = {
  title: 'Программа курса по русскому языку',
  schedule: 'Ср в 19:20 и Чт в 19:20',
  modules: [
    {
      name: 'Работа над сочинением ЕГЭ',
      lessons: [
        {
          name: 'Разбор демоверсии ЕГЭ. Сочинение (постановка проблемы)',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Сочинение (проблема, комментарий, позиция автора)',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Сочинение (собственное мнение, заключение)',
          day: 'пт',
          date: '23.02',
        },
      ],
    },
    {
      name: 'Орфография. Правописание морфем',
      lessons: [
        {
          name: 'Задание 9',
          day: 'ср',
          date: '28.02',
        },
        {
          name: 'Задание 10',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Задание 11',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Задание 12',
          day: 'пт',
          date: '08.03',
        },
      ],
    },
    {
      name: 'Орфография',
      lessons: [
        {
          name: 'Задание 13',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Задание 14',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'Задание 15',
          day: 'ср',
          date: '20.03',
        },
      ],
    },
    {
      name: 'Пунктуация',
      lessons: [
        {
          name: 'Задание 16',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Задание 17',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Задание 18',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Задания 19, 20',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Задание 21',
          day: 'пт',
          date: '05.04',
        },
      ],
    },
    {
      name: 'Грамматические нормы',
      lessons: [
        {
          name: 'Задание 7',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Задание 8',
          day: 'пт',
          date: '12.04',
        },
      ],
    },
    {
      name: 'Работа с текстом. Стили и типы. Средства связи. Средства выразительности',
      lessons: [
        {
          name: 'Задания 22-23. Задание 1',
          day: 'ср',
          date: '17.04',
        },
        {
          name: 'Задание 24',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Задания 25; 1-3',
          day: 'ср',
          date: '24.04',
        },
        {
          name: 'Задание 26',
          day: 'пт',
          date: '26.04',
        },
      ],
    },
    {
      name: 'Языковые нормы.',
      lessons: [
        {
          name: 'Задания 4, 5, 6. Постановка ударения. Употребление паронимов. Лексические нормы.',
          day: 'ср',
          date: '01.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение. Пунктуация (16-21). Орфография (9-10). Задание 6. Сочинение: природа',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Повторение. Задания по тексту (22-26). Орфография (11-12). Задание 4. Сочинение: искусство',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Повторение. Задание 8. Орфография (13-14). Задание 7. Сочинение: русский язык',
          day: 'пт',
          date: '10.05',
        },
        {
          name: 'Повторение. Пунктуация (16-21). Орфография (15). Задания 1-3. Сочинение: дружба',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Повторение. Задания по тексту (22-26). Орфография (9-15). Сочинение: война',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '24.05',
        },
      ],
    },
  ],
};

const egePhysics = {
  title: 'Программа курса по физике',
  schedule: 'Вт в 19:20 и Сб в 12:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Механика. Векторы. Ускорение',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Средняя скорость. Свободное падение. Движение по окружности.',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'Относительное движение. Горизонтальный бросок. Баллистическое движение',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Силы в природе. Законы Ньютон',
          day: 'вт',
          date: '27.02',
        },
        {
          name: 'Энергия. Импульс. Законы сохранения',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Механическая энергия, закон сохранения энергии. Механическая работа, мощность',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Сила Архимеда. Закон Паскаля. Волны',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Механическое равновесие. Маятники. Колебания',
          day: 'вт',
          date: '12.03',
        },
        {
          name: 'Установление соответствия. Объяснение явлений. Изменение физических величин в процессах',
          day: 'сб',
          date: '16.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Основное уравнение МКТ',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Первое начало термодинамики. Работа идеального газа',
          day: 'сб',
          date: '23.03',
        },
        {
          name: 'КПД тепловых машин. Циклы',
          day: 'вт',
          date: '26.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Влажность. Теплоёмкость. Теплота плавления. Теплота парообразования',
          day: 'сб',
          date: '30.03',
        },
        {
          name: 'МКТ. Объяснение явлений. Изменение физических величин в процессах',
          day: 'вт',
          date: '02.04',
        },
        {
          // eslint-disable-next-line max-len,vue/max-len
          name: 'Электрическое поле. Магнитное поле. Закон Кулона. Напряженность и потенциал электрического поля. Магнитный поток. Силы Ампера и Лоренца.',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Направление магнитного поля',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Электрическая ёмкость, заряд, сила тока. Закон Ома. Закон Джоуля-Ленца',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Электрические схемы. Электромагнитная индукция',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Электродинамика. Объяснение явлений',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Электричество и магнетизм. Оптика. Линзы',
          day: 'вт',
          date: '23.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Ядерная физика. Квантовая физика',
          day: 'вт',
          date: '30.04',
        },
        {
          name: 'Закон радиоактивного распада. Атомные спектры. Энергетические уровни',
          day: 'сб',
          date: '04.05',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Внешний фотоэффект. Энергия и импульс фотона',
          day: 'вт',
          date: '07.05',
        },
        {
          name: 'Методы научного познания. Элементы астрофизики',
          day: 'сб',
          date: '11.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '21.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '04.06',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '07.06',
        },
      ],
    },
  ],
};

const egeChemistry = {
  title: 'Программа курса по химии',
  schedule: 'Вт в 17:40 и Пт в 16:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Электронное строение атома. Периодический закон. Понятие степени окисления и валентности',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Классификация химических связей. Типы кристаллических решеток',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'Скорость химических реакций. Смещение химического равновесия',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Классификация и номенклатура неорганических веществ. Химические свойства оксидов',
          day: 'вт',
          date: '27.02',
        },
        {
          name: 'Химические свойства металлов. Химические свойства неметаллов',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Химические свойства гидроксидов и кислот. Аммиак',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Химические свойства солей',
          day: 'пт',
          date: '08.03',
        },
        {
          name: 'Ионный обмен и диссоциация',
          day: 'вт',
          date: '12.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Окислительно-восстановительные реакции в неорганической химии',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'Электролиз. Гидролиз',
          day: 'вт',
          date: '19.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Алканы. Алкены',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Алкины. Алкадиены',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'Циклические соединения',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Ароматические углеводороды',
          day: 'вт',
          date: '02.04',
        },
        {
          name: 'Углеводороды в заданиях ЕГЭ',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Гидроксильные вещества: спирты, простые эфиры, фенолы',
          day: 'вт',
          date: '09.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Карбонильные вещества: альдегиды, кетоны',
          day: 'пт',
          date: '12.04',
        },
        {
          name: 'Карбоксильные вещества: карбоновые кислоты, сложные эфиры, соли',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Кислородсодержащие вещества в заданиях ЕГЭ',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Амины. Аминокислоты. Белки, жиры, углеводы',
          day: 'вт',
          date: '23.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Классификация реакций в химии. Качественные реакции. Химия и жизнь',
          day: 'пт',
          date: '26.04',
        },
        {
          name: 'Классификация реакций. Механизмы протекания реакций в органической химии',
          day: 'вт',
          date: '30.04',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '07.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '10.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '21.05',
        },
      ],
    },
  ],
};

const egeInformatics = {
  title: 'Программа курса по информатике',
  schedule: 'Пн в 16:00 и Ср в 16:00',
  modules: [
    {
      name: 'Информация и ее обработка',
      lessons: [
        {
          name: 'Системы счисления и действия в них',
          day: 'пн',
          date: '19.02',
        },
        {
          name: 'Позиционные СС (задание 14)',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Условие Фано (задание 4)',
          day: 'пн',
          date: '26.02',
        },
        {
          name: 'Кодирование информации (задание 7)',
          day: 'ср',
          date: '28.02',
        },
        {
          name: 'Информационный объем сообщения (задание 11)',
          day: 'пн',
          date: '06.03',
        },
        {
          name: 'Количество информации (задание 8)',
          day: 'ср',
          date: '11.03',
        },
      ],
    },
    {
      name: 'Алгебра логики',
      lessons: [
        {
          name: 'Таблицы истинности и лог схемы (задание 2)',
          day: 'пн',
          date: '13.03',
        },
        {
          name: 'Логические выражения. Часть 1 (задание 15)',
          day: 'ср',
          date: '18.03',
        },
        {
          name: 'Логические выражения. Часть 2 (задание 15)',
          day: 'пн',
          date: '20.03',
        },
        {
          name: 'Обобщающий урок по теме «Алгебра логики»',
          day: 'ср',
          date: '27.03',
        },
      ],
    },
    {
      name: 'Алгоритмы и их исполнители',
      lessons: [
        {
          name: 'Алгоритмы для формальных исполнителей. Часть 1 (задание 5)',
          day: 'пн',
          date: '01.04',
        },
        {
          name: 'Алгоритмы для формальных исполнителей. Часть 2 (задание 12)',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Рекурсивные алгоритмы (задание 16)',
          day: 'пн',
          date: '25.03',
        },
        {
          name: 'Анализ результатов исполнения алгоритма (задание 23)',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Обобщающий урок по теме «Алгоритмы и их исполнители»',
          day: 'пн',
          date: '01.04',
        },
      ],
    },
    {
      name: 'Программирование',
      lessons: [
        {
          name: 'Основные конструкции языков программирования (задание 6)',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Алгоритм обработки массивов (задача 17)',
          day: 'пн',
          date: '08.04',
        },
        {
          name: 'Обработка символьных строк (задание 24)',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Анализ программы с циклами и условными операторами (задание 22)',
          day: 'пн',
          date: '15.04',
        },
        {
          name: 'Определение количества делителей (задание 25)',
          day: 'ср',
          date: '17.04',
        },
        {
          name: 'Методы сортировки массива (задание 26)',
          day: 'пн',
          date: '22.04',
        },
        {
          name: 'Методы сортировки массива (задание 26)',
          day: 'ср',
          date: '25.04',
        },
        {
          name: 'Обработка данных в виде последовательных чисел (задание 27)',
          day: 'пн',
          date: '29.04',
        },
        {
          name: 'Обработка данных в виде последовательных чисел. Продолжение',
          day: 'ср',
          date: '01.05',
        },
      ],
    },
    {
      name: 'Базы данных и графы',
      lessons: [
        {
          name: 'Базы данных (задание 3) + текстовый редактор (задача 10)',
          day: 'пн',
          date: '06.05',
        },
        {
          name: 'Поиск путей в графе (задание 1)',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Электронные таблицы (задания 9, 18)',
          day: 'пн',
          date: '13.05',
        },
        {
          name: 'Электронные таблицы (задания 9, 18)',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Задание 13, Протокол TCP/IP, организация компьютерных сетей',
          day: 'пн',
          date: '20.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '29.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '03.06',
        },
        {
          name: 'Как себя вести на экзамене, какие программы, что можно, что нельзя',
          day: 'ср',
          date: '05.06',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '10.06',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '12.06',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '17.06',
        },
        {
          name: 'Как сдавать экзамен онлайн',
          day: 'ср',
          date: '19.06',
        },
        {
          name: 'Итоговый тест',
          day: 'пн',
          date: '24.06',
        },
      ],
    },
  ],
};

const egeHistory = {
  title: 'Программа курса по истории',
  schedule: 'Ср в 17:40 и Сб в 13:30',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Полезная информация. Мировая история',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Восточные славяне в древности',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Удельная Русь. Золотая Орда',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Московская Русь. Московское княжество в XIV-XV вв. Культура Русь XI-XV вв.',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Эпоха Ивана Грозного. Культура XVI в.',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Смутное время',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Правление первых Романовых',
          day: 'сб',
          date: '09.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Эпоха Петра I',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Дворцовые перевороты',
          day: 'сб',
          date: '16.03',
        },
        {
          name: 'Правление Екатерины II',
          day: 'ср',
          date: '20.03',
        },
        {
          name: 'Павел I. Культура XVII-XVIII вв.',
          day: 'сб',
          date: '23.03',
        },
        {
          name: 'Александр I',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Николай I',
          day: 'сб',
          date: '30.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Александр II',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Общественные движения XIX века',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Александр III',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Культура XIX века',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Николай II',
          day: 'ср',
          date: '17.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Революция 1917 г.',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Гражданская война. Культура начала XX века',
          day: 'ср',
          date: '24.04',
        },
        {
          name: 'СССР в 1920-е – 1930-е гг.',
          day: 'сб',
          date: '27.04',
        },
        {
          name: 'Великая Отечественная война. Часть 1',
          day: 'ср',
          date: '01.05',
        },
        {
          name: 'Великая Отечественная война. Часть 2',
          day: 'сб',
          date: '04.05',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Поздний сталинизм и Хрущев',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Брежнев',
          day: 'сб',
          date: '11.05',
        },
        {
          name: 'Горбачев и распад СССР',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Советская культура и наука. Россия на современном этапе',
          day: 'сб',
          date: '18.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '29.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '01.06',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '05.06',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '07.06',
        },
      ],
    },
  ],
};

const egeSocial = {
  title: 'Программа курса по обществознанию',
  schedule: 'Пн в 16:00 и Пт в 17:40',
  modules: [
    {
      name: 'Социальные отношения',
      lessons: [
        {
          name: 'Социальная роль, социализация и семья.',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Социальная стратификация и социальные группы',
          day: 'пн',
          date: '19.02',
        },
        {
          name: 'Этнические отношения.',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Социальные нормы',
          day: 'пт',
          date: '26.02',
        },
        {
          name: 'Этнические отношения',
          day: 'пн',
          date: '01.03',
        },
        {
          name: 'Социальные нормы',
          day: 'пт',
          date: '04.03',
        },
      ],
    },
    {
      name: 'Экономика',
      lessons: [
        {
          name: 'Экономика и экономические системы',
          day: 'пт',
          date: '08.03',
        },
        {
          name: 'Рынок и финансы',
          day: 'пн',
          date: '11.03',
        },
        {
          name: 'Государство и проблемы в экономике.',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'Банковская система и государственный бюджет',
          day: 'пт',
          date: '18.03',
        },
        {
          name: 'Мировая экономика',
          day: 'пн',
          date: '22.03',
        },
      ],
    },
    {
      name: 'Политика',
      lessons: [
        {
          name: 'Власть и государство',
          day: 'пт',
          date: '25.03',
        },
        {
          name: 'Политические режимы.',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Политическая система',
          day: 'пн',
          date: '01.04',
        },
        {
          name: 'Участники политики.',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Политика.',
          day: 'пт',
          date: '08.04',
        },
      ],
    },
    {
      name: 'Право',
      lessons: [
        {
          name: 'Государство в РФ',
          day: 'пн',
          date: '12.04',
        },
        {
          name: 'Система права',
          day: 'пт',
          date: '15.04',
        },
        {
          name: 'Конституция РФ и права человека',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Гражданское право',
          day: 'пн',
          date: '22.04',
        },
        {
          name: 'Семейное право',
          day: 'пт',
          date: '26.04',
        },
        {
          name: 'Трудовое право',
          day: 'пт',
          date: '29.04',
        },
        {
          name: 'Процессуальное право',
          day: 'пн',
          date: '03.05',
        },
      ],
    },
    {
      name: 'Человек и общество',
      lessons: [
        {
          name: 'Общество и человек',
          day: 'пт',
          date: '06.05',
        },
        {
          name: 'Познание, культура и образование',
          day: 'пт',
          date: '10.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение - Интенсив',
          day: 'пн',
          date: '13.05',
        },
        {
          name: 'Повторение - Интенсив',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение - Интенсив',
          day: 'пт',
          date: '20.05',
        },
        {
          name: 'Повторение - Интенсив',
          day: 'пн',
          date: '24.05',
        },
        {
          name: 'Повторение - Интенсив',
          day: 'пт',
          date: '27.05',
        },
        {
          name: 'Повторение - Интенсив',
          day: 'пт',
          date: '03.06',
        },
      ],
    },
  ],
};

export const egeModules = {
  'matematika-profil': {
    ...egeMathProfile,
    quantity: calculateLessons(egeMathProfile),
    minutes: calculateMinutes(egeMathProfile),
  },
  matematika: {
    ...egeMath,
    quantity: calculateLessons(egeMath),
    minutes: calculateMinutes(egeMath),
  },
  biologiya: {
    ...egeBiology,
    quantity: calculateLessons(egeBiology),
    minutes: calculateMinutes(egeBiology),
  },
  'anglijskij-yazyk': {
    ...egeEnglish,
    quantity: calculateLessons(egeEnglish),
    minutes: calculateMinutes(egeEnglish),
  },
  literatura: {
    ...egeLiterature,
    quantity: calculateLessons(egeLiterature),
    minutes: calculateMinutes(egeLiterature),
  },
  'russkij-yazyk': {
    ...egeRussian,
    quantity: calculateLessons(egeRussian),
    minutes: calculateMinutes(egeRussian),
  },
  fizika: {
    ...egePhysics,
    quantity: calculateLessons(egePhysics),
    minutes: calculateMinutes(egePhysics),
  },
  himiya: {
    ...egeChemistry,
    quantity: calculateLessons(egeChemistry),
    minutes: calculateMinutes(egeChemistry),
  },
  informatika: {
    ...egeInformatics,
    quantity: calculateLessons(egeInformatics),
    minutes: calculateMinutes(egeInformatics),
  },
  istoriya: {
    ...egeHistory,
    quantity: calculateLessons(egeHistory),
    minutes: calculateMinutes(egeHistory),
  },
  obshchestvoznanie: {
    ...egeSocial,
    quantity: calculateLessons(egeSocial),
    minutes: calculateMinutes(egeSocial),
  },
};

const ogeEnglish = {
  title: 'Программа курса по английскому языку',
  schedule: 'Вт в 16:00 и Сб в 10:30',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Family and friends + Impersonal sentences / There is / there are',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Daily routines + Phonetics',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'School + Present Simple & Present Сontinuous',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Revision 1',
          day: 'вт',
          date: '27.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Making a career + Past Simple & Past Continuous',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Food + Present Perfect & Present Perfect Continuous',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Health + Past Perfect & Past Perfect Continuous',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Weather + Future',
          day: 'вт',
          date: '12.03',
        },
        {
          name: 'Revision 2',
          day: 'сб',
          date: '16.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Climate change + Passive',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Money + Countability',
          day: 'сб',
          date: '23.03',
        },
        {
          name: 'Travel + Articles',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'City life + Pronouns',
          day: 'сб',
          date: '30.03',
        },
        {
          name: 'Revision 3',
          day: 'вт',
          date: '02.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Life in the country + Comparatives and superlatives',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Sport + Questions',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Art + Conditionals',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Fashion + Wish / Prepositions',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Revision 4',
          day: 'сб',
          date: '20.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Politics',
          day: 'вт',
          date: '23.04',
        },
        {
          name: 'Linking words',
          day: 'сб',
          date: '27.04',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Revision',
          day: 'вт',
          date: '30.04',
        },
        {
          name: 'Revision',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Revision',
          day: 'вт',
          date: '07.05',
        },
        {
          name: 'Revision',
          day: 'сб',
          date: '11.05',
        },
        {
          name: 'Revision',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Revision',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Revision',
          day: 'вт',
          date: '21.05',
        },
      ],
    },
  ],
};

const ogeBiology = {
  title: 'Программа курса по биологии',
  schedule: 'Ср в 19:20 и Сб в 13:30',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Строение эукариотической клетки',
          day: 'сб',
          date: '24.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Царство Бактерии. Вирусы. Царство Грибы.',
          day: 'ср',
          date: '28.02',
        },
        {
          name: 'Царство Растения. Ткани растений и органы.',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Систематика растений. Низшие растения и высшие споровые растения',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Отделы Голосеменные и Покрытосеменные растения',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Царство Животные. Простейшие и Кишечнополостные',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Типы Плоские, Круглые и Кольчатые черви',
          day: 'сб',
          date: '16.03',
        },
        {
          name: 'Типы Моллюски и Членистоногие',
          day: 'ср',
          date: '20.03',
        },
        {
          name: 'Хордовые. Надкласс Рыбы',
          day: 'сб',
          date: '23.03',
        },
        {
          name: 'Земноводные и Рептилии',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Птицы и Млекопитающие',
          day: 'сб',
          date: '30.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Ткани животных. ОДС',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Внутренняя среда организма. Иммунитет',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Сердечно-сосудистая система человека',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Нервная система человека',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Вегетативная нервная система. Анализаторы',
          day: 'ср',
          date: '17.04',
        },
        {
          name: 'Дыхательная система. Эндокринная система',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Пищеварительная система. Выделительная система',
          day: 'ср',
          date: '24.04',
        },
        {
          name: 'Обмен веществ. Нормы питания. Витамины',
          day: 'сб',
          date: '27.04',
        },
        {
          name: 'Высшая нервная деятельность. Половая система',
          day: 'ср',
          date: '01.05',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Основы эволюции',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Основы экологии',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Основы генетики',
          day: 'сб',
          date: '11.05',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Разбор заданий 1 части',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Разбор заданий 1 части',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Разбор заданий 2 части',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Разбор заданий 2 части',
          day: 'сб',
          date: '25.05',
        },
      ],
    },
  ],
};

const ogeInformatics = {
  title: 'Программа курса по информатике',
  schedule: 'Пн в 17:40 и Ср в 17:40',
  modules: [
    {
      name: 'Кодирование информации',
      lessons: [
        {
          name: 'Кодирование информации',
          day: 'пн',
          date: '21.02',
        },
        {
          name: 'Представление чисел, арифметические операции и перевод чисел в разных СС',
          day: 'ср',
          date: '26.02',
        },
        {
          name: 'Способы кодирования и декодирования информации',
          day: 'пн',
          date: '28.02',
        },
        {
          name: 'Определение объема информации',
          day: 'ср',
          date: '06.03',
        },
      ],
    },
    {
      name: 'Алгебра логики',
      lessons: [
        {
          name: 'Элементы математической логики',
          day: 'пн',
          date: '11.03',
        },
        {
          name: 'Поисковые запросы с использованием логических выражений',
          day: 'ср',
          date: '13.03',
        },
      ],
    },
    {
      name: 'Моделирование',
      lessons: [
        {
          name: 'Формальные описания реальных процессов',
          day: 'пн',
          date: '18.03',
        },
        {
          name: 'Графические модели',
          day: 'ср',
          date: '20.03',
        },
      ],
    },
    {
      name: 'Компьютерные сети',
      lessons: [
        {
          name: 'Принципы адресации в интернете',
          day: 'пн',
          date: '27.03',
        },
        {
          name: 'Работа с поисковой системой ПК',
          day: 'ср',
          date: '01.04',
        },
        {
          name: 'Организация файловой системы',
          day: 'пн',
          date: '03.04',
        },
      ],
    },
    {
      name: 'Работа с текстовым редактором',
      lessons: [
        {
          name: 'Работа с текстовым процессором',
          day: 'ср',
          date: '25.03',
        },
      ],
    },
    {
      name: 'Создание презентаций',
      lessons: [
        {
          name: 'Работа с программой для создания презентаций',
          day: 'пн',
          date: '27.03',
        },
        {
          name: 'Разбор заданий №13',
          day: 'ср',
          date: '01.04',
        },
      ],
    },
    {
      name: 'Электронные таблицы',
      lessons: [
        {
          name: 'Знакомство с электронными таблицами',
          day: 'пн',
          date: '03.04',
        },
        {
          name: 'Работа с большим массивом данных',
          day: 'ср',
          date: '08.04',
        },
        {
          name: 'Разбор заданий №14',
          day: 'пн',
          date: '10.04',
        },
      ],
    },
    {
      name: 'Алгоритмизация и программирование',
      lessons: [
        {
          name: 'Алгоритмы',
          day: 'ср',
          date: '15.04',
        },
        {
          name: 'Простейший алгоритм в среде формального исполнителя',
          day: 'пн',
          date: '17.04',
        },
        {
          name: 'Разбор заданий №15',
          day: 'ср',
          date: '22.04',
        },
        {
          name: 'Основы языка программирования',
          day: 'пн',
          date: '25.04',
        },
        {
          name: 'Основы языка программирования ч2',
          day: 'ср',
          date: '29.04',
        },
        {
          name: 'Условные операторы python',
          day: 'пн',
          date: '01.05',
        },
        {
          name: 'Условные операторы python ч2',
          day: 'ср',
          date: '06.05',
        },
        {
          name: 'Сложные условия',
          day: 'пн',
          date: '08.05',
        },
        {
          name: 'Циклические алгоритмы',
          day: 'ср',
          date: '13.05',
        },
        {
          name: 'Решение задач повышенного уровня',
          day: 'пн',
          date: '15.05',
        },
        {
          name: 'Разбор задач с нестандартным алгоритмом решения',
          day: 'ср',
          date: '20.05',
        },
        {
          name: 'Разбор задач с нестандартным алгоритмом решения',
          day: 'пн',
          date: '22.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'ср',
          date: '27.05',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '29.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '03.06',
        },
        {
          name: 'Повторение',
          day: 'пн',
          date: '05.06',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '10.06',
        },
      ],
    },
  ],
};

const ogeHistory = {
  title: 'Программа курса по истории',
  schedule: 'Ср в 19:20 и Сб в 12:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Восточные славяне в древности',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Культура Руси XI-XV вв.',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Эпоха Ивана Грозного.',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Культура XVI в.',
          day: 'ср',
          date: '06.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Смутное время',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Правление первых Романовых',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Эпоха Петра I',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Дворцовые перевороты',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Правление Екатерины II',
          day: 'сб',
          date: '16.03',
        },
        {
          name: 'Павел I.',
          day: 'ср',
          date: '20.03',
        },
        {
          name: 'Культура XVII-XVIII вв.',
          day: 'сб',
          date: '23.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Александр I',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Николай I',
          day: 'сб',
          date: '30.03',
        },
        {
          name: 'Общественные движения начала XIX в.',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Повторение IX-XVIII в.',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Александр II',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Александр III',
          day: 'сб',
          date: '13.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Общественные движения второй половины XIX в.',
          day: 'ср',
          date: '17.04',
        },
        {
          name: 'Культура XIX в.',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Николай II',
          day: 'ср',
          date: '24.04',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение IX--нач. XX',
          day: 'сб',
          date: '27.04',
        },
        {
          name: 'Повторение: Киевская Русь',
          day: 'ср',
          date: '01.05',
        },
        {
          name: 'Повторение: Монгольское Иго',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Повторение: Крепостное право',
          day: 'ср',
          date: '08.05',
        },
        {
          name: 'Повторение: Московская Русь и Возвышение Москвы',
          day: 'сб',
          date: '11.05',
        },
        {
          name: 'Повторение: Смутное время и первые Романовы',
          day: 'ср',
          date: '15.05',
        },
        {
          name: 'Внешняя политика XVII-XVIII вв.',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Повторение. Имперская Россия от Петра I до Александра I',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение. Имперская Россия от Николая I  до Александра III',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение. От Александра III до Николая II',
          day: 'ср',
          date: '29.05',
        },
      ],
    },
  ],
};

const ogeMath = {
  title: 'Программа курса по математике',
  schedule: 'Ср в 16:00 и Пт в 15:30',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Знакомство с ОГЭ по математике. Обыкновенные дроби',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Обыкновенные и десятичные дроби',
          day: 'ср',
          date: '21.02',
        },
        {
          name: 'Степени. Корни',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Сложные преобразования алгебраических выражений + формулы сокращенного умножения',
          day: 'ср',
          date: '06.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Уравнения',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Неравенства',
          day: 'ср',
          date: '06.03',
        },
        {
          name: 'Уравнения. Неравенства. Их совокупности',
          day: 'пт',
          date: '08.03',
        },
        {
          name: 'Вероятности',
          day: 'ср',
          date: '13.03',
        },
        {
          name: 'Арифметически прогрессии и геометрические прогрессии',
          day: 'пт',
          date: '15.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Тригонометрия в геометрии',
          day: 'ср',
          date: '20.03',
        },
        {
          name: 'Треугольник: углы и отрезки',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Равнобедренные и равносторонние треугольники',
          day: 'ср',
          date: '27.03',
        },
        {
          name: 'Теоремы синусов и косинусов. Площадь треугольника',
          day: 'пт',
          date: '29.03',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Расчеты по формулам. Практические задачи №1-3',
          day: 'ср',
          date: '03.04',
        },
        {
          name: 'Решение практических задач №4-5',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Сравнение чисел и координатная прямая',
          day: 'ср',
          date: '10.04',
        },
        {
          name: 'Текстовые задачи на движение',
          day: 'пт',
          date: '12.04',
        },
        {
          name: 'Текстовые задачи на совместную работу; сплавы и смеси',
          day: 'ср',
          date: '17.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Параллельные прямые. Подобие треугольников',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Трапеция',
          day: 'ср',
          date: '24.04',
        },
        {
          name: 'Параллелограмм и ромб',
          day: 'пт',
          date: '26.04',
        },
        {
          name: 'Прямоугольник и квадрат. Обобщение темы "Четырехугольники"',
          day: 'ср',
          date: '01.05',
        },
        {
          name: 'Углы и отрезки, связанные с окружностью',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Вписанные и описанные окружности',
          day: 'ср',
          date: '08.05',
        },
      ],
    },
    {
      name: 'Модуль 6',
      lessons: [
        {
          name: 'Графики линейной и квадратичной функций',
          day: 'пт',
          date: '10.05',
        },
        {
          name: 'Графики функций y=k/x и y= √x',
          day: 'ср',
          date: '15.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '24.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '29.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '31.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '05.06',
        },
      ],
    },
  ],
};

const ogeLiterature = {
  title: 'Программа курса по литературе',
  schedule: 'Чт в 19:20 и Сб в 12:00',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Теория литературы',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Слово о полку Игореве',
          day: 'чт',
          date: '22.02',
        },
        {
          name: 'Лирика Ломоносова и Державина. Творчество Крылова. Повторение',
          day: 'сб',
          date: '24.02',
        },
        {
          name: 'Фонвизин "Недоросль"',
          day: 'чт',
          date: '07.03',
        },
        {
          name: 'Карамзин "Бедная Лиза"',
          day: 'сб',
          date: '02.03',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Творчество Жуковского',
          day: 'чт',
          date: '07.03',
        },
        {
          name: 'Грибоедов "Горе от ума"',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Лирика Пушкина',
          day: 'чт',
          date: '14.03',
        },
        {
          name: 'Пушкин "Цыганы", "Повести Белкина"',
          day: 'сб',
          date: '16.03',
        },
        {
          name: 'Пушкин "Евгений Онегин"',
          day: 'чт',
          date: '21.03',
        },
        {
          name: 'Пушкин "Капитанская дочка"',
          day: 'сб',
          date: '23.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Лирика Лермонтова',
          day: 'чт',
          date: '28.03',
        },
        {
          name: 'Поэмы Лермонтова',
          day: 'сб',
          date: '30.03',
        },
        {
          name: 'Лермонтов "Герой нашего времени"',
          day: 'чт',
          date: '04.04',
        },
        {
          name: 'Гоголь "Шинель", Ревизор"',
          day: 'сб',
          date: '06.04',
        },
        {
          name: 'Гоголь "Мертвые души"',
          day: 'чт',
          date: '11.04',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Творчество Островского и Тургенева',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Лирика Фета, Тютчева, Некрасова',
          day: 'чт',
          date: '18.04',
        },
        {
          name: 'Творчество Салтыкова-Щедрина',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Творчество Достоевского и Толстого',
          day: 'чт',
          date: '25.04',
        },
        {
          name: 'Творчество Чехова',
          day: 'сб',
          date: '27.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Творчество Блока',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Творчество Маяковского',
          day: 'чт',
          date: '09.05',
        },
        {
          name: 'Творчество Есенина',
          day: 'сб',
          date: '11.05',
        },
      ],
    },
    {
      name: 'Модуль 6',
      lessons: [
        {
          name: 'Творчество Шолохова и Солженицына',
          day: 'чт',
          date: '16.05',
        },
        {
          name: 'Творчество Твардовского, Творчество Шукшина',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Лирика второй половины XX в. Проза второй половины XX в.',
          day: 'чт',
          date: '23.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '30.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '01.06',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '06.06',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '07.06',
        },
        {
          name: 'Повторение',
          day: 'чт',
          date: '13.06',
        },
      ],
    },
  ],
};

const ogeSocial = {
  title: 'Программа курса по обществознанию',
  schedule: 'Пн в 19:20 и Пт в 19:20',
  modules: [
    {
      name: 'Социология',
      lessons: [
        {
          name: 'Общество и семья',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'Нации и межнациональные отношения',
          day: 'вт',
          date: '21.02',
        },
        {
          name: 'Социальные нормы, социальный контроль',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Социальный конфликт',
          day: 'вт',
          date: '26.02',
        },
      ],
    },
    {
      name: 'Экономика',
      lessons: [
        {
          name: 'Экономика и экономические системы',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Государственное регулирование рыночной экономики',
          day: 'вт',
          date: '04.03',
        },
        {
          name: 'Труд и финансы',
          day: 'пт',
          date: '11.03',
        },
        {
          name: 'Государство в экономике',
          day: 'вт',
          date: '12.03',
        },
      ],
    },
    {
      name: 'Политика',
      lessons: [
        {
          name: 'Власть и государство. Формы государства.',
          day: 'пт',
          date: '15.03',
        },
        {
          name: 'Политические режимы, демократия',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Участники политики и органы местного самоуправления',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'Гражданское общество и правовое государство',
          day: 'вт',
          date: '26.03',
        },
      ],
    },
    {
      name: 'Право',
      lessons: [
        {
          name: 'Понятие права и нормы права',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Конституция и власть в РФ',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Правонарушения и судебная система',
          day: 'пт',
          date: '12.04',
        },
        {
          name: 'Права и свободы',
          day: 'вт',
          date: '16.04',
        },
      ],
    },
    {
      name: 'Человек и общество',
      lessons: [
        {
          name: 'Общество и общественные отношения',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Человек и личность',
          day: 'вт',
          date: '07.05',
        },
        {
          name: 'Человек в обществе',
          day: 'пт',
          date: '10.05',
        },
        {
          name: 'Культура и наука',
          day: 'вт',
          date: '14.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '22.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '24.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '29.05',
        },
        {
          name: 'Повторение',
          day: 'пт',
          date: '31.05',
        },
        {
          name: 'Повторение',
          day: 'ср',
          date: '05.06',
        },
      ],
    },
  ],
};

const ogeRussian = {
  title: 'Программа курса по русскому языку',
  schedule: 'Вт в 19:20 и Пт в 17:40',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Изложение. Приёмы сжатия текста',
          day: 'пт',
          date: '16.02',
        },
        {
          name: 'СОЧИНЕНИЕ. Тема 9.3',
          day: 'вт',
          date: '20.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Сочинение. Анализ текста. Задание 6',
          day: 'пт',
          date: '23.02',
        },
        {
          name: 'Орфографический анализ. Правописание приставок. Задание 5',
          day: 'вт',
          date: '27.02',
        },
        {
          name: 'Орфографический анализ. Правописание корней. Задание 5',
          day: 'пт',
          date: '01.03',
        },
        {
          name: 'Сочинение. Тема 9.2',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Орфографический анализ. Правописание суффиксов. Задание 5',
          day: 'пт',
          date: '08.03',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Сочинение',
          day: 'вт',
          date: '12.03',
        },
        {
          name: '-Н и -НН в разных частях речи',
          day: 'пт',
          date: '15.03',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Орфографический анализ. Правописание окончаний. Задание 5',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Орфографический анализ. Правописание предлогов, союзов и наречий. Задание 5',
          day: 'пт',
          date: '22.03',
        },
        {
          name: 'НЕ и НИ со словами разных частей речи. Задание 5',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'Грамматическая основа. Словосочетание. Задания 2, 4',
          day: 'пт',
          date: '29.03',
        },
        {
          name: 'Пунктуационный анализ. ССП и ОЧП. Задание 3',
          day: 'вт',
          date: '02.04',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Пунктуационный анализ. Обособленные члены. Вводные слова. Обращения. Задание 3',
          day: 'пт',
          date: '05.04',
        },
        {
          name: 'Пунктуационный анализ. СПП. БСП. Задание 3',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Пунктуационный анализ. Задание 3',
          day: 'пт',
          date: '12.04',
        },
        {
          name: 'Анализ средств выразительности. Метафора. Эпитет. Фразеологизм. Задание 7',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Анализ средств выразительности. Олицетворение. Гипербола. Литота. Сравнение. Задание 7',
          day: 'пт',
          date: '19.04',
        },
        {
          name: 'Лексический анализ. Синонимы. Антонимы. Переносное значение слова. Задание 8',
          day: 'вт',
          date: '23.04',
        },
        {
          name: 'Лексический анализ. Лексика пассивного запаса. Стилистически окрашенная лексика. Задание 8',
          day: 'пт',
          date: '26.04',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение. Пунктуация. Средства выразительности. Лексика',
          day: 'вт',
          date: '30.04',
        },
        {
          name: 'Повторение. Орфография. Корни. Приставки. Суффиксы',
          day: 'пт',
          date: '03.05',
        },
        {
          name: 'Повторение. Орфография. Окончания. Суффиксы. Наречия. Предлоги. Союзы',
          day: 'вт',
          date: '07.05',
        },
        {
          name: 'Повторение. Синтаксис',
          day: 'пт',
          date: '10.05',
        },
        {
          name: 'Повторение. Пунктуация. ССП, ОЧП и обособленные члены предложения',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Повторение. Пунктуация. Сложное предложение. Тире, двоеточие, кавычки',
          day: 'пт',
          date: '17.05',
        },
        {
          name: 'Повторение. Задания 2, 3, 4, 6-8',
          day: 'вт',
          date: '21.05',
        },
        {
          name: 'Повторение. Задания 4, 5, 6-8',
          day: 'пт',
          date: '24.05',
        },
        {
          name: 'Общее повторение. Изложение',
          day: 'вт',
          date: '28.05',
        },
      ],
    },
  ],
};

const ogePhysics = {
  title: 'Программа курса по физике',
  schedule: 'Вт в 17:40 и Сб в 10:30',
  modules: [
    {
      name: 'Модуль 1',
      lessons: [
        {
          name: 'Что такое ОГЭ по физике?',
          day: 'сб',
          date: '17.02',
        },
        {
          name: 'Кинематика. Равномерное и равноускоренное движение',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'Кинематика. Движение по окружности',
          day: 'сб',
          date: '24.02',
        },
      ],
    },
    {
      name: 'Модуль 2',
      lessons: [
        {
          name: 'Механические колебания и волны',
          day: 'вт',
          date: '27.02',
        },
      ],
    },
    {
      name: 'Модуль 3',
      lessons: [
        {
          name: 'Виды сил. Сложение векторов. Динамика. Законы Ньютона',
          day: 'сб',
          date: '02.03',
        },
        {
          name: 'Закон всемирного тяготения',
          day: 'вт',
          date: '05.03',
        },
        {
          name: 'Сила тяжести и вес',
          day: 'сб',
          date: '09.03',
        },
        {
          name: 'Сила упругости. Закон Гука',
          day: 'вт',
          date: '12.03',
        },
        {
          name: 'Сила трения. Виды трения',
          day: 'сб',
          date: '16.03',
        },
      ],
    },
    {
      name: 'Модуль 4',
      lessons: [
        {
          name: 'Импульс. ЗСИ',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Работа. Мощность. Энергия. ЗСЭ',
          day: 'сб',
          date: '23.03',
        },
      ],
    },
    {
      name: 'Модуль 5',
      lessons: [
        {
          name: 'Гидро и аэростатика. Закон Архимеда. Работа с формулами',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'Внутренняя энергия. Виды теплопередачи.',
          day: 'сб',
          date: '30.03',
        },
        {
          name: 'Количество теплоты.Фазовые переходы.',
          day: 'вт',
          date: '02.04',
        },
        {
          name: 'Насыщенный пар. Влажность.',
          day: 'сб',
          date: '06.04',
        },
      ],
    },
    {
      name: 'Модуль 6',
      lessons: [
        {
          name: 'Заряд. Закон сохранения заряда.',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Сила тока. Напряжение. Сопротивление.',
          day: 'сб',
          date: '13.04',
        },
        {
          name: 'Последовательное и параллельное соединение',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Работа и мощность тока. Закон Джоуля-Ленца',
          day: 'сб',
          date: '20.04',
        },
        {
          name: 'Магнитное поле. Сила Лоренца и сила Ампера.',
          day: 'вт',
          date: '23.04',
        },
      ],
    },
    {
      name: 'Модуль 7',
      lessons: [
        {
          name: 'Оптика',
          day: 'сб',
          date: '27.04',
        },
      ],
    },
    {
      name: 'Модуль 8',
      lessons: [
        {
          name: 'Атом. Радиоактивные распады',
          day: 'вт',
          date: '30.04',
        },
      ],
    },
    {
      name: 'Модуль 9',
      lessons: [
        {
          name: 'Разбор типового варианта',
          day: 'сб',
          date: '04.05',
        },
        {
          name: 'Разбор типового варианта',
          day: 'вт',
          date: '07.05',
        },
      ],
    },
    {
      name: 'Интенсив',
      lessons: [
        {
          name: 'Повторение',
          day: 'сб',
          date: '11.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '18.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '21.05',
        },
        {
          name: 'Повторение',
          day: 'сб',
          date: '25.05',
        },
        {
          name: 'Повторение',
          day: 'вт',
          date: '28.05',
        },
      ],
    },
  ],
};

const ogeChemistry = {
  title: 'Программа курса по химии',
  schedule: 'Вт в 16:00 и Чт в 17:40',
  modules: [
    {
      name: 'Модуль 1. Введение в общую химию',
      lessons: [
        {
          name: 'Введение в химию: понятие о веществах, молекулах и атомах',
          day: 'чт',
          date: '15.02',
        },
        {
          name: 'Электронное строение атома',
          day: 'вт',
          date: '20.02',
        },
        {
          name: 'Периодический закон Д.И. Менделеева.',
          day: 'чт',
          date: '22.02',
        },
        {
          name: 'Степень окисления и валентность',
          day: 'вт',
          date: '27.02',
        },
        {
          name: 'Типы химической связи',
          day: 'чт',
          date: '29.02',
        },
        {
          name: 'Повторение. Задания линий 1- 6',
          day: 'вт',
          date: '05.03',
        },
      ],
    },
    {
      name: 'Модуль 2. Неорганическая химия',
      lessons: [
        {
          name: 'Классификация неорганических веществ',
          day: 'чт',
          date: '07.03',
        },
        {
          name: 'Классификация химических реакций',
          day: 'вт',
          date: '12.03',
        },
        {
          name: 'Электролитическая диссоциация и РИО',
          day: 'чт',
          date: '14.03',
        },
        {
          name: 'Окислительно - восстановительные реакции',
          day: 'вт',
          date: '19.03',
        },
        {
          name: 'Повторение. Задания линий 7, 11, 13, 14, 15, 20',
          day: 'чт',
          date: '21.03',
        },
      ],
    },
    {
      name: 'Модуль 3. Общие химические свойства',
      lessons: [
        {
          name: 'Оксиды и основания',
          day: 'вт',
          date: '26.03',
        },
        {
          name: 'Амфотерные оксиды',
          day: 'чт',
          date: '28.03',
        },
        {
          name: 'Химические свойства кислот',
          day: 'вт',
          date: '02.04',
        },
        {
          name: 'Химические свойства солей',
          day: 'чт',
          date: '04.04',
        },
        {
          name: 'Качественные реакции в химии',
          day: 'вт',
          date: '09.04',
        },
        {
          name: 'Повторение. Задания линий 8,9,10, 12, 17, 21',
          day: 'чт',
          date: '11.04',
        },
      ],
    },
    {
      name: 'Модуль 4. Химия элементов',
      lessons: [
        {
          name: 'Водород и галогены.',
          day: 'вт',
          date: '16.04',
        },
        {
          name: 'Кислород и сера.',
          day: 'чт',
          date: '18.04',
        },
        {
          name: 'Азот и фосфор.',
          day: 'вт',
          date: '23.04',
        },
        {
          name: 'Углерод и кремний',
          day: 'чт',
          date: '25.04',
        },
        {
          name: 'Щелочные и щелочно-земельные металлы',
          day: 'вт',
          date: '30.04',
        },
        {
          name: 'Алюминий и железо',
          day: 'чт',
          date: '02.05',
        },
      ],
    },
    {
      name: 'Модуль 5. Практика',
      lessons: [
        {
          name: 'Практическая часть ОГЭ. Реакции ионного обмена',
          day: 'чт',
          date: '09.05',
        },
        {
          name: 'Практическая часть ОГЭ. Реакции замещения. Индикаторы',
          day: 'вт',
          date: '14.05',
        },
        {
          name: 'Отработка части 1 ОГЭ',
          day: 'чт',
          date: '16.05',
        },
        {
          name: 'Отработка части 2 ОГЭ',
          day: 'вт',
          date: '21.05',
        },
        {
          name: 'Повторение пройденного материала',
          day: 'чт',
          date: '23.05',
        },
      ],
    },
  ],
};

export const ogeModules = {
  'anglijskij-yazyk': {
    ...ogeEnglish,
    quantity: calculateLessons(ogeEnglish),
    minutes: calculateMinutes(ogeEnglish),
  },
  biologiya: {
    ...ogeBiology,
    quantity: calculateLessons(ogeBiology),
    minutes: calculateMinutes(ogeBiology),
  },
  informatika: {
    ...ogeInformatics,
    quantity: calculateLessons(ogeInformatics),
    minutes: calculateMinutes(ogeInformatics),
  },
  istoriya: {
    ...ogeHistory,
    quantity: calculateLessons(ogeHistory),
    minutes: calculateMinutes(ogeHistory),
  },
  literatura: {
    ...ogeLiterature,
    quantity: calculateLessons(ogeLiterature),
    minutes: calculateMinutes(ogeLiterature),
  },
  matematika: {
    ...ogeMath,
    quantity: calculateLessons(ogeMath),
    minutes: calculateMinutes(ogeMath),
  },
  obshchestvoznanie: {
    ...ogeSocial,
    quantity: calculateLessons(ogeSocial),
    minutes: calculateMinutes(ogeSocial),
  },
  'russkij-yazyk': {
    ...ogeRussian,
    quantity: calculateLessons(ogeRussian),
    minutes: calculateMinutes(ogeRussian),
  },
  fizika: {
    ...ogePhysics,
    quantity: calculateLessons(ogePhysics),
    minutes: calculateMinutes(ogePhysics),
  },
  himiya: {
    ...ogeChemistry,
    quantity: calculateLessons(ogeChemistry),
    minutes: calculateMinutes(ogeChemistry),
  },
};
